<template>
  <div class="topic-link-tags-container">
    <span>
      <button
        v-if="showAddTagBtn"
        class="btn topic-links-new-tag-btn"
        @click="addTag"
      >Add Tag +</button>
      <span
        v-if="showAddTagInput"
        class="topic-links-add-tag-input"
      >
        <autocomplete-input
          inputId="newTag"
          :suggestions="filteredTags"
          @getSuggestions="tagSearch"
          @setInput="(tag) => newTag = tag"
        />
        <button
          class="btn topic-links-new-tag-btn"
          type="button"
          @click="addNewTag"
          @enter="addNewTag"
        >
          Add
        </button>
      </span>
    </span>
    <span
      v-for="tag in newTags"
      :key="tag"
      class="btn btn--primary topic-links-selected-tag"
    >{{ tag }} <button
      type="button"
      @click="deleteTag(tag)"
    >&#x2716;</button></span>
  </div>
</template>

<script>
import AutocompleteInput from './AutocompleteInput'

export default {
  name: 'TopicLinksTag',
  components: { AutocompleteInput },
  props: ['tags', 'fullTagList'],
  emits: ['newTag'],
  data() {
    return {
      showAddTagBtn: true,
      showAddTagInput: false,
      newTag: '',
      newTags: this.tags,
      filteredTags: []
    }
  },
  methods: {
    addTag() {
      this.showAddTagInput = true
      this.showAddTagBtn = false
      this.$nextTick(() => {
        document.querySelector('input#newTag')?.focus()
      })
    },
    addNewTag() {
      if (this.newTag != '') {
        if (!this.newTags.find(t => t === this.newTag)) {
          this.newTags.push(this.newTag)
        }
        this.returnTags()
        this.showAddTagBtn = true
        this.showAddTagInput = false
        this.newTag = ''
      }
    },
    deleteTag(tag) {
      this.newTags = this.newTags.filter((t) => {
        return t != tag
      })
      this.returnTags()
    },
    returnTags() {
      this.$emit('addNewTag', this.newTags)
    },
    tagSearch(term) {
      this.newTag = term
      if (this.newTag.length >= 3) {
        this.filteredTags = this.fullTagList.filter(t => {
          return t.includes(this.newTag)
        })
      } else {
        this.filteredTags = []
      }
    }
  }
}
</script>

<style>
.topic-link-tags-container {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: flex-start;
  align-items: center;
}
button.topic-links-new-tag-btn {
  font-size: 0.85em;
  padding: 5px;
  margin: auto;
  color: #fff;
  background: #999999;
}
span.topic-links-selected-tag {
  font-size: 0.85em;
  padding: 5px;
}
.topic-links-new-tag-input {
  width: 200px;
  border-radius: 6px;
  height: 100%;
  vertical-align: bottom;
  font-size: 0.85em;
}
.topic-links-add-tag-input {
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  position: relative;
  gap: 5px;
}
.topic-links-filtered-tags {
  width: 200px;
  position: absolute;
  left: 0;
  list-style: none;
  margin-left: 0;
  border: 1px solid #cecbca;
}
.topic-links-filtered-tags li {
  padding: 5px;
}
.topic-links-filtered-tags li:hover {
  background: #999999;
  color: #fff;
}
.topic-links-filtered-tags li button {
  width: 100%;
  text-align: left;
}
</style>
